module.exports = __webpack_public_path__ + "static/remix-47fd56f5a650dbe25a4fb627644d5a94.mp3";